import { render } from "./index.vue?vue&type=template&id=c567f288"
const script = {}

import "./index.vue?vue&type=style&index=0&id=c567f288&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__